import * as React from "react";
import { IdTooltipAdjust } from "../../constants/IdTooltipAdjust";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ButtonSecondary } from "../generic/common/ButtonSecondary";
import { IconBuilding } from "../generic/common/icon-building/IconBuilding";
import { IdIconBuildingContext } from "../generic/common/icon-building/IdIconBuildingContext";
import { TradeTransitionArrow } from "../generic/common/TradeTransitionArrow";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
export var StoreItemBuildingPurchase = function (_a) {
    var _b = _a.item, balancing = _b.balancing, buildingRewardInfo = _b.buildingRewardInfo, costResourceInfo = _b.costResourceInfo, onBuyPackage = _a.onBuyPackage;
    var buildingReward = balancing.buildingReward;
    var _c = buildingReward[0], amount = _c.amount, stageId = _c.stageId;
    var _d = buildingRewardInfo, name = _d.name, locaKey = _d.locaKey;
    return (React.createElement("div", { className: "store-menu-detail__purchase" },
        React.createElement("div", { className: "resource-trade-info__wrapper " + IdStyles.InventoryBuyContainerCost },
            React.createElement("div", { className: "resource-trade-info__item" },
                React.createElement(ResourceIcon, { resource: costResourceInfo, styleId: IdStyles.IconMedium, tooltipVerticalAdjust: -IdTooltipAdjust.Small }),
                React.createElement("div", { className: IdStyles.TextBoldPrimary },
                    React.createElement(NumberFormat, { amount: costResourceInfo.amount }))),
            React.createElement(TradeTransitionArrow, null),
            React.createElement("div", { className: "resource-trade-info__item" },
                React.createElement(TooltipText, { id: locaKey, anchor: IdTooltipAnchor.Bottom, adjustVertical: IdTooltipAdjust.Medium },
                    React.createElement("div", { className: "flex flex--guts" },
                        React.createElement(IconBuilding, { level: stageId, buildingName: name, context: IdIconBuildingContext.LevelUpReward }))),
                React.createElement("div", { className: IdStyles.TextBoldPrimary },
                    React.createElement(NumberFormat, { amount: amount })))),
        React.createElement(ButtonSecondary, { onClick: function () { return onBuyPackage(amount); } },
            React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.buy }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/StoreItemBuildingPurchase.tsx
// module id = 2758
// module chunks = 3